module.exports = __webpack_public_path__ + "static/media/mappin.ed1a9e36.svg";